"use client";

import { useContext } from "react";
import { UserContext } from "@/contexts/user-context";
import Script from "next/script";
import { Analytics } from "@/components/common/cookies-script/scripts/analytics";
import { Advertising } from "@/components/common/cookies-script/scripts/advertising";
import { resolvePublicEnvValue } from "@/service/public-env";
import { CookieSettings } from "@/components/common/cookie-settings/cookie-settings";
import { useEnvContext } from "next-runtime-env";
import { GoogleTagManager } from "@/components/common/cookies-script/scripts/analytics/google-tag-manager";

export const CookiesScripts = () => {
  const { isLoggedIn, isBusinessUser } = useContext(UserContext);

  const {
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENABLED,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV,
    NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID,
    NEXT_PUBLIC_POSTHOG_ENABLED,
  } = useEnvContext();

  const posthog = `
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_cPGIHRRdstNoobBCUk3JhvDq7zouvIwBOkUyNRyYcE6', {
        api_host: 'https://posthog.remedium.md',
        defaults: '2025-05-24',
        autocapture: false,
        capture_pageview: false,
        person_profiles: 'always'
    })
    `;

  return (
    <>
      <CookieSettings />
      <Script id={"initial-cookies"} strategy={"beforeInteractive"}>
        {`
          ${resolvePublicEnvValue(NEXT_PUBLIC_POSTHOG_ENABLED) ? posthog : ""}
          let isAccept = ${
            isLoggedIn || isBusinessUser
              ? `"1"`
              : "localStorage.getItem('cookie-accept')"
          };
        `}
      </Script>

      <Script id={"google-tag-manager"} strategy={"beforeInteractive"}>
        {`
          ${
            resolvePublicEnvValue(NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENABLED)
              ? `
                ${GoogleTagManager(
                  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ENV as string,
                  NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as string,
                )}
              `
              : ""
          }
        `}
      </Script>

      <Analytics />

      <Advertising />
    </>
  );
};
